import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { LeadsProvider } from './contexts/LeadsContext';
import { Sidebar } from './components/Sidebar';
import { TopBar } from './components/TopBar';
import { Overview } from './pages/Overview';
import { Leads } from './pages/Leads';
import { Loans } from './pages/Loans';
import { FollowUps } from './pages/FollowUps';
import { Reports } from './pages/Reports';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2rit3v7n2pyrh">
      <LeadsProvider data-id="element-1" data-mp="2mlu5ue0ah7o0">
      <div className="flex h-full min-h-screen w-full bg-canvas text-ink" data-id="element-2" data-mp="2mmlt91jqfz37">
        <Sidebar data-id="element-3" data-mp="31aqeoda66opo" />
        <div className="flex min-w-0 flex-1 flex-col" data-id="element-4" data-mp="31b8lg3ugklbu">
          <TopBar data-id="element-5" data-mp="31ctfztgrw49p" />
          <main className="flex-1 overflow-y-auto px-4 py-5 sm:px-6" data-id="element-6" data-mp="2wk0bn6p7uxy5">
            <Routes data-id="element-7" data-mp="2wip6p3k1bk5g">
              <Route path="/" element={<Overview data-id="element-9" data-mp="28tw4ipctkg2e" />} data-id="element-8" data-mp="28ufpkexrnkkn" />
              <Route path="/leads" element={<Leads data-id="element-11" data-mp="28sbar1ybx15l" />} data-id="element-10" data-mp="28t4ju9krg2qw" />
              <Route path="/loans" element={<Loans data-id="element-13" data-mp="23u9uspw79hyc" />} data-id="element-12" data-mp="23vkv2fqfs7kp" />
              <Route path="/follow-ups" element={<FollowUps data-id="element-15" data-mp="3ijxoypkvdyjd" />} data-id="element-14" data-mp="23v2s7099qv3t" />
              <Route path="/reports" element={<Reports data-id="element-17" data-mp="3ijpbavgxap74" />} data-id="element-16" data-mp="3ikqwhsrnks2k" />
            </Routes>
          </main>
        </div>
      </div>
      </LeadsProvider>
    </BrowserRouter>;
}